var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.97 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.31 7.75-7.75 7.75h-6zM2.72 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25h-6C4.36 2.75 2.72 4.39 2.72 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.29 17.1-1.14-2.88c-.16-.41-.73-.79-1.16-.79l-6 .02a.749.749 0 1 1 0-1.5l6-.02H8c1.05 0 2.17.76 2.56 1.74l.91 2.3 2.06-5.22c.31-.78.86-.89 1.09-.91.23-.01.79.04 1.18.78l1.04 1.97c.18.34.72.67 1.11.67h4.06c.41 0 .75.34.75.75s-.34.75-.75.75h-4.06c-.95 0-1.99-.63-2.43-1.47l-.78-1.48-2.1 5.29c-.37.86-.96.96-1.19.96-.24 0-.82-.09-1.16-.96z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineHealth);
export default __webpack_public_path__ + "static/media/vuesax-outline-health.fd82cef79a07259369f8f625430fc122.svg";
export { ForwardRef as ReactComponent };